import { post as getPost } from './posts';

export const getComment = (state, commentId) => state.data.comments[commentId];

export const postComments = (state, postId) =>
  (getPost(state, postId) || {}).comments || [];

export const commentCount = (state, postId) =>
  postComments(state, postId).length;
